<template>
  <div class="productcenter1html">
    <div class="productcenter1head">
      <div class="productcenter1headtext">
        <p
          style="
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 24px;
          "
        >
          多账号下单工具
        </p>
        <p
          style="
            font-size: 15px;
            color: #000000;
            line-height: 20px;
            letter-spacing: 1px;
          "
        >
          支持多账号画线下单、多账号条件单、多账号止损单。支持跨期货公司的不同账号，支持跨多种后台系统的不同账号。
        </p>
      </div>
    </div>
    <div class="productcenter1body">
      <div class="productcenter1bodytag">
        <ul style="padding-top: 70px">
          <li class="pli">
            <div v-bind:class="[form.oneth ? class4 : class3]"></div>
            <div v-bind:class="[form.oneth ? class1 : class5]" @click="oneth">
              <div class="taghead"></div>
              <div class="tagmid">简介</div>
              <div style="width: 5px; height: 40px; float: left"></div>
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fourth ? class4 : class3]"></div>
            <div v-bind:class="[form.fourth ? class1 : class2]" @click="fourth">
              <div class="taghead"></div>
              <div class="tagmid">多账号登录</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.oneth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fiveth ? class4 : class3]"></div>
            <div v-bind:class="[form.fiveth ? class1 : class2]" @click="fiveth">
              <div class="taghead"></div>
              <div class="tagmid">查看各账号持仓</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.fourth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.sixth ? class4 : class3]"></div>
            <div v-bind:class="[form.sixth ? class1 : class2]" @click="sixth">
              <div class="taghead"></div>
              <div class="tagmid">设置不同下单手数</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.fiveth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.seventh ? class4 : class3]"></div>
            <div
              v-bind:class="[form.seventh ? class1 : class2]"
              @click="seventh"
            >
              <div class="taghead"></div>
              <div class="tagmid">一带多模式</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.sixth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fourteenth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.fourteenth ? class1 : class2]"
              @click="fourteenth"
            >
              <div class="taghead"></div>
              <div class="tagmid">投资经理/交易员模式</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.seventh"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.eightth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.eightth ? class1 : class2]"
              @click="eightth"
            >
              <div class="taghead"></div>
              <div class="tagmid">批量撤单、改价</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.fourteenth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.nineth ? class4 : class3]"></div>
            <div v-bind:class="[form.nineth ? class1 : class2]" @click="nineth">
              <div class="taghead"></div>
              <div class="tagmid">多账号云条件单/预备单</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.eightth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.tenth ? class4 : class3]"></div>
            <div v-bind:class="[form.tenth ? class1 : class2]" @click="tenth">
              <div class="taghead"></div>
              <div class="tagmid">多账号云止损单/止盈单</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.nineth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.eleventh ? class4 : class3]"></div>
            <div
              v-bind:class="[form.eleventh ? class1 : class2]"
              @click="eleventh"
            >
              <div class="taghead"></div>
              <div class="tagmid">多账号画线下单</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.tenth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.twelveth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.twelveth ? class1 : class2]"
              @click="twelveth"
            >
              <div class="taghead"></div>
              <div class="tagmid">多账号下单参数设置</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.eleventh"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.thirteenth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.thirteenth ? class1 : class6]"
              @click="thirteen"
            >
              <div class="taghead"></div>
              <div class="tagmid">常见问题解答</div>
              <div class="tagfoot"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.twelveth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div
              style="width: 10px; height: 7px; float: right; ine-height: 7px"
              v-if="form.thirteenth"
            >
              <img
                src="../../assets/images/qianlan-jia.png"
                style="display: block"
              />
            </div>
          </li>
        </ul>
        <div class="pdf"><a href="https://ftpc.wenhua.com.cn/files/guide/wh7/download/%E5%A4%9A%E8%B4%A6%E5%8F%B7%E4%B8%8B%E5%8D%95%E5%B7%A5%E5%85%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf" target="_blank">下载多账号下单工具操作手册</a></div>
      </div>
      <div class="productcenter1bodytext" ref="box">
        <div style="width: 780px; border-radius: 2%; position: relative">
          <div class="midtext">
            <div v-if="form.oneth" style="text-align: justify">
              <h4 class="head4" id="one">一、简介</h4>
              <p class="pproduct">
                “多账号”批量下单是用操作一个账号的过程，达到操作多个账号进行下单交易的目的。
              </p>
              <p class="pproduct">
                多账号支持跨不同期货公司、跨不同交易后台（CTP、金仕达、恒生多种后台）登陆，支持最多配置20个交易账号进行"多账号"下单交易，<router-link
                  to="/trade"
                  target="_blank"
                  >点击查看睿期Wh7支持交易的期货公司</router-link
                >。
              </p>
              <p class="pproduct">
                注：多账号支持内外盘期货交易，要在账户区“期货户”、“外盘户”处分别登录。
              </p>
            </div>
            <div v-if="form.fourth">
              <h4 class="head4" id="four">二、多账号登录</h4>
              <p class="pproduct">
                “多账号”下单需要同时登录多个账号，点击软件右下方的"期货户"按钮打开登录界面，在登录界面登陆多个账号。
              </p>
              <p class="pproduct">如下图所示，是如何登录多个账号：</p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-1.jpg" /></p>
            </div>
            <div v-if="form.fiveth">
              <h4 class="head4" id="five">三、查看各账号持仓</h4>
              <p class="pproduct">
                在左侧账号树中勾选哪个账号，右侧持仓栏就显示哪个账号的持仓，如下图所示：
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-2.jpg" /></p>
              <p class="pproduct">
                可将多个账号合并为账号“组”，对组内账号同时下单，如下图，是如何设置账号“组”。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-3.png')"></BaseBigimg>
              <p class="pproduct">
                通过右键菜单“调入账号”和“调入组”，可切换账号列表和组界面查看持仓情况。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-4.jpg" /></p>
            </div>
            <div v-if="form.sixth">
              <h4 class="head4" id="six">四、设置不同下单手数</h4>
              <p class="pproduct">
                多账号下单各个账号的资金量可能是不同的，下单的手数也是不同的。软件提供“倍率模式”和“份数模式”两种下单模式，可以根据下单需求，设置账号之间按倍数比例下单或者不同的下单手数按份下单，对多个账号统筹管理。
              </p>
              <h5 class="head5">（一）倍率模式</h5>
              <p class="pproduct">
                倍率模式适合按账号资金比例关系下单，想要实现资金最大化利用的用户。各个账号可设置不同的下单倍数，下单时按比例计算每个账号的下单手数。
              </p>
              <h5 class="head5">1、对单账号设置下单倍数</h5>
              <p class="pproduct">
                如下图，是对单账号设置下单倍数的方法，倍数支持设置为小数。
              </p>
              <p class="pproduct">
                以下图为例，若在下单板上下单1手，则当前账号下单3*1手=3手。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-5.jpg" /></p>
              <h5 class="head5">2、对账号组设置下单倍数</h5>
              <p class="pproduct">
                如下图，是对账号组设置下单倍数的操作方法，倍数支持设置为小数。
              </p>
              <p class="pproduct">
                以下图为例，若在下单板上下单1手，当前账号下单3*1手=3手。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-6.jpg" /></p>
              <h5 class="head5">（二）份数模式</h5>
              <p class="pproduct">
                份数模式适合资金量大、管理账户数量较多的机构用户。各账号的下单手数按份定义，根据下单份数分别计算下单数量，可以严格按照下单计划的手数执行下单管理。
              </p>
              <h5 class="head5">1、对单账号设置每份下单手数</h5>
              <p class="pproduct">如下图，是对单账号设置每份下单手数的方法。</p>
              <p class="pproduct">
                以下图为例，若在下单板下单1份，当前账号对应下单1*3手=3手。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-34.jpg" /></p>
              <h5 class="head5">2、对账号组设置每份下单手数</h5>
              <p class="pproduct">
                如下图，是对组中账号设置每份下单手数的方法。
              </p>
              <p class="pproduct">
                以下图为例，若在下单板下单1份，当前账号对应下单1*3手=3手。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-35.jpg" /></p>
            </div>
            <div v-if="form.seventh">
              <h4 class="head4" id="seven">五、一带多模式</h4>
              <p class="pproduct">
                适用于交易员一个人管理多个交易账号的使用场景，可一键同时对多个账号进行下单。支持按倍率或份数自动计算交易手数，并提供了三键下单和传统下单两种交易界面可供选择。
              </p>
              <h5 class="head5">（一）倍率模式下单界面</h5>
              <p class="pproduct">
                如下图，是倍率模式的下单界面。下单操作灵活便捷，勾选参与交易的账号或组，点击即可快速下单。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-7.jpg" /></p>
              <p class="pproduct">
                如下图，是倍率模式下单时调整委托价格的方法；在持仓列表可进行快速平仓等操作。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-8.jpg" /></p>
              <p class="ppro">
                ①点击【价格】，会弹出排队价、对手价、市价、最新价、超价委托方式，选中其中一个，再点击下单按钮就会以选中方式发委托。
              </p>
              <p class="ppro" style="font-size: 14px">
                “排队价”时，买入以买价发委托，卖出以卖价发委托。
              </p>
              <p class="ppro" style="font-size: 14px">
                “对手价”时，买入以卖价发委托，卖出以买价发委托。
              </p>
              <p class="ppro" style="font-size: 14px">
                “市价”时，买入以涨停价发委托，卖出以跌停价发委托。（交易所撮合最优价成交，因此和市价下单效果是一样的）
              </p>
              <p class="ppro" style="font-size: 14px">
                “最新价”时，买入/卖出都以最新价发委托。
              </p>
              <p class="ppro" style="font-size: 14px">
                “超价”时，买入以“基准价”+N个变动价位发委托，卖出以“基准价”-N个变动价位发委托。
              </p>
              <p class="ppro" style="font-size: 14px">
                “基准价”和N可以在交易界面左侧菜单【超价参数】中设置。
              </p>
              <p class="ppro">
                ②在持仓列表双击鼠标左键会对选中合约以对手价发平仓委托；或者在持仓列表单击鼠标右键，在弹出窗口中可以对持仓进行平仓操作。
              </p>
              <h5 class="head5">（二）份数模式下单界面</h5>
              <p class="pproduct">
                如下图，是份数模式的下单界面，提供专业操盘下单界面，选择参与交易的账号或组，选择买卖开平方向即可精准下单。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-37.jpg')"></BaseBigimg>
              <p class="pproduct">
                份数模式也支持调整委托价格、快速平仓等便捷操作，如下图①和③。特别的，份数模式还支持账号持仓同步功能，可在开仓时自动根据各账户持仓情况决定是否补仓，实现更专业的多账户管理效果，如②所示：
              </p>
              <p class="pproduct">
                勾选后，若账号中的持仓大于等于要下单手数，该账号将不进行下单；若单账号中的持仓小于下单手数，则按差额进行补仓，自动保持各账号持仓之间的固定比例，无须手动调仓。
              </p>
              <p class="pproduct">
                不勾选，则按下单份数计算出的手数进行下单，与账号当前持仓数量无关。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-38.jpg" /></p>
              <h5 class="head5">（三）下单模式切换</h5>
              <p class="pproduct">
                如下图，在账户参数设置->选项设置中，可切换多账号下单模式。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-36.jpg" /></p>
              <!-- <p class="pproduct">
              如：单账号***950（李女士）、***450（张先生）的下单倍数分别设置为2和1，当下单界面的手数为1，那么委托时***950（李女士）的委托手数为2×1倍=2手，***450（张先生） 
              的委托手数为1×1倍=1手。
            </p>
            <p class="pimg"><img src="@/../public/proimg2/dzh-7.jpg" /></p>
            <p class="pproduct">
              登录“一带多”下单后，会在交易界面看到账户号，选择要交易的账户号和合约后，点击下单按钮。下单过程只需要像交易单账号一样进行交易即可。
            </p>
            <p class="pproduct">
              除了该基本下单方法外，下面介绍一些下单界面的实用小功能，如下图标注。
            </p>
            <p class="pproduct">
              ①点击【价格】，会弹出排队价、对手价、市价、最新价、超价委托方式（详见下面注释），选中其中一个，再点击下单按钮就会以选中方式发委托。
            </p>
            <p class="pproduct">
              ②在持仓列表双击鼠标左键会对选中合约以对手价发平仓委托；或者在持仓列表单击鼠标右键，在弹出窗口中可以对持仓进行平仓操作。
            </p>
            <p class="pimg"><img src="@/../public/proimg2/dzh-8.jpg" /></p>
            <p class="pproduct">注：</p>
            <p class="ppro">“排队价”时，买入以买价发委托，卖出以卖价发委托。</p>
            <p class="ppro">“对手价”时，买入以卖价发委托，卖出以买价发委托。</p>
            <p class="ppro">
              “市价”时，买入以涨停价发委托，卖出以跌停价发委托。（交易所撮合最优价成交，因此和市价下单效果是一样的）
            </p>
            <p class="ppro">“最新价”时，买入/卖出都以最新价发委托。</p>
            <p class="ppro">
              “超价”时，买入以“基准价”+N个变动价位发委托，卖出以“基准价”-N个变动价位发委托。
            </p>
            <p class="ppro">
              “基准价”和N可以在交易界面左侧菜单【超价参数】中设置。
            </p> -->
            </div>
            <div v-if="form.fourteenth">
              <h4 class="head4" id="eight">六、投资经理/交易员模式</h4>
              <p class="pproduct">
                投资经理/交易员模式适用于投资经理只负责主账号交易，交易员管理其他多个账号跟随主账号交易的使用场景。交易员账号支持按照倍率自动同步投资经理账号的委托下单，交易员监控交易过程，可手动撤单、追价、同步持仓。
              </p>
              <p class="pproduct">
                如下图，是投资经理/交易员模式的交易员窗口。需要同时登录投资经理账户和交易员账号，选择投资经理账户并点击“启动”按钮后，交易员账户会按照设置的倍数，自动同步投资经理账户的委托下单。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/tzjl-2.jpg')"></BaseBigimg>
              <p class="pproduct">
                注：多账号支持内外盘期货交易，要在账户区“期货户”、“外盘户”处分别登录。
              </p>
              <p class="pproduct">
                如下图是投资经理/交易员模式中，交易员对交易员账户订单进行撤单、追价的方法，还可以一键对交易员账户同步投资经理持仓。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/tzjl-1.jpg')"></BaseBigimg>
              <p class="pproduct">
                ①选中交易员订单中需要处理的订单，后续操作对该订单生效。
              </p>
              <p class="pproduct">
                ②对选中的交易员订单支持手动撤单、追价等便捷操作。
              </p>
              <p class="pproduct">
                ③同步持仓功能，在交易员账户持仓与投资经理账户持仓不匹配时，点击“同步持仓”按钮，软件自动计算交易员账户应该处理的持仓数量，并弹出下单委托提示。
              </p>
            </div>
            <div v-if="form.eightth">
              <h4 class="head4" id="eight">七、批量撤单、改价</h4>
              <p class="pproduct">
                调入要操作的组，对组进行的委托如果未成交，在委托列表单击鼠标右键->撤单/改价，可以对该组的未成交委托完成批量撤单或批量改价，不需要针对组中的合约进行一个一个撤单或改价的重复操作。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-9.jpg" /></p>
            </div>
            <div v-if="form.nineth">
              <h4 class="head4" id="nine">八、多账号云条件单/预备单</h4>
              <h5 class="head5">1、对单账号设置云端条件单、预备单</h5>
              <p class="pproduct">
                如下图是对单账号设置云端条件单的操作方法，可在【条件单】列表点击右键，对已设置的云端条件单进行修改。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-10.jpg" /></p>
              <p class="pproduct">
                如下图，是对单账号设置预备单的操作方法，在【预备单】列表中可以添加、发出或删除预备单。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-11.jpg" /></p>
              <h5 class="head5">2、对账号“组”设置云端条件单、预备单</h5>
              <p class="pproduct">
                多账号“组”同样支持云端条件单，组条件单在云端储存，本机断电、断网、关机都不受影响。
              </p>
              <p class="pproduct">
                如下图，是对账户组设置云端条件单的操作方法。可在【条件单】列表点击右键，对已设置的条件单进行修改。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-12.jpg" /></p>
              <p class="pproduct">
                如下图，是对账户组设置预备单的操作方法。可在【预备单】列表点击右键，添加、发出或删除预备单。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-13.jpg" /></p>
              <p class="pproduct">注：</p>
              <p class="pproduct">
                1、画线条件单的“委托价格”和“是否启动止损”可以在下单参数设置界面—>条件单参数中进行设置。
              </p>
              <p class="pproduct">
                2、预备单不能自动委托，需要手动在“预备单”列表右键->立即发出，才会发送委托。
              </p>
              <p class="pproduct">
                3、开盘触发条件单需要在非交易时间设置，在开盘时间会触发。商品期货的9:00、10:30、
                13:30，股指期货的09：30、13:00，夜盘的21:00的时间都属于开盘时间。
              </p>
              <p class="pproduct">
                4、设置时间和价格条件单中，会有“永久有效”和“当前交易日有效”的选项。
              </p>
              <p class="ppro">永久有效：条件单设置后在云端运行永久有效。</p>
              <p class="ppro">
                当前交易日有效：只在本交易日当日有效，下一个交易日失效。
              </p>

              <p class="pproduct">
                5、时间条件单根据条件单服务器时间触发（条件单服务器时间和交易所后台时间会进行校时）。
              </p>
              <p class="pproduct">
                6、条件单中的“条件”价格是判断是否发出委托的依据，委托时会按照“订单”里的委托形式下单，如设置了对手价，那么会以市场上当时的对手价发出委托；成交价是由交易所撮合成交的结果，所以成交价可能和条件价格不同。
              </p>
            </div>
            <div v-if="form.tenth">
              <h4 class="head4" id="ten">九、多账号云止损单/止盈单</h4>
              <h5 class="head5">1、软件中提供的止损止盈策略</h5>
              <h5 class="head5">①、限价止损、限价止盈原理：</h5>
              <p class="ppro">传统止损止盈方式，以设置的固定价差做止损止盈。</p>
              <h5 class="head5">②、跟踪止损原理：</h5>
              <p class="pro">
                这是一种动态止损方法，止损价位会随着盈利的增加而变化；这种方法可以最大程度实现“让盈利奔跑”。做多开仓，设置跟踪止损后的最高价每上涨一个价位，止损平仓价就跟着上涨一个价位，当价格从<img
                  src="@/../public/proimg2/zgj.gif"
                />回撤了设置的止损价差时，触发止损。下图为做多跟踪止损示意图，做空则相反。
              </p>
              <p class="pproduct">
                <img
                  src="@/../public/proimg2/zgj.gif"
                />：此最高价是从设置止损后开始记录的，不一定是开仓后的最高价。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-14.gif" /></p>
              <h5 class="head5">③、保本策略原理：</h5>
              <p class="pproduct">
                做多开仓后，在“开仓均价+设置的保本价差”位置产生了一条保本线，最新价超过设置的保本止损线后，再回落到这个保本止损线时才触发止损。这是一种现代人的止损思想——盈利状态下止损；目的是保住赚到的利润，文华软件中通常称之为“保本”。下图为做多保本止损示意图，做空则相反。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-15.gif" /></p>

              <h5 class="head5">2、止损开仓</h5>
              <p class="pproduct">
                止损开仓可以在开仓同时设置任意止损止盈价，您可以选择相应账号或者组设置止损开仓。
                按下图所示步骤开仓成交后，持仓单会自带止损止盈设置。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-16.jpg" /></p>
              <p class="pproduct">注：</p>
              <p class="pproduct">
                1、止损价或止盈价设置为0，相当于不启动止损或止盈。
              </p>
              <p class="pproduct">
                2、买开仓动态跟踪的价差=图中②里"价格"-"止损价"，卖开仓动态跟踪的价差=图中②里"止损价"-"价格"。如果差值小于0，相当于不启动止损。
              </p>
              <h5 class="head5">3、设置开仓自动止损止盈</h5>
              <p class="pro">
                开仓自动止损止盈是指点下单界面的下单按钮后开的仓，持仓自动带止损止盈设置。
                如下图所示是如何设置开仓自动止损止盈：
              </p>
              <p class="pro">
                点击下单按钮开仓后，持仓会按照“默认策略”和“国内合约默认止损点差参数”加载止损止盈。
              </p>
              <p class="pro">
                按下图所示步骤开仓成交后，持仓单会自动带止损止盈设置。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-17.jpg" /></p>
              <h5 class="head5">4、对持仓合约设置止损止盈</h5>
              <p class="pro">
                对账户已经持有的合约，可在持仓列表的右键菜单中添加止损/止盈单。
              </p>
              <h5 class="head5">① 对单账号设置云端止损单/止盈单</h5>
              <p class="pro">
                如下图，是对单账号设置云端止损/止盈单的操作方法。在持仓列表点击右键，选择“设置云止损/止盈/保本单”，可对已选单账号中的合约添加止损/止盈单。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-18.jpg')"></BaseBigimg>
              <p class="pproduct">
                注：对账号设置的止损/止盈单，默认手数是已选账户内该合约的全部持仓；
              </p>
              <h5 class="head5">② 对账号“组”设置云端止损单/止盈单</h5>
              <p class="pro">
                账号“组”也支持云端止损/止盈单。如下图，是对账号组设置云端止损/止盈单的操作方法。在持仓列表点击右键，选择“设置云止损/止盈/保本单”，可对组中的合约添加止损/止盈单。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-19.jpg" /></p>
              <p class="pproduct">
                注：对组设置的止损/止盈单，默认手数是交易组所有账户中该合约的全部持仓。
              </p>
              <h5 class="head5">5、止损止盈单的删除、修改、暂停、启动</h5>
              <h5 class="head5">① 在持仓列表修改</h5>
              <p class="pro">
                如下图所示，在持仓列表右键选择“设置云止损/止盈/保本单”，可在弹出的损盈信息列表上进行调整。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-20.jpg')"></BaseBigimg>
              <h5 class="head5">② 在损盈单列表修改</h5>
              <p class="pro">
                如下图所示，在损盈单列表点击鼠标右键，可以删除、修改、暂停、启动云端止损止盈单。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-21.jpg" /></p>
              <p class="pro">
                在止损单列表的右键菜单修改单账号/组止损单时，需要点开止损单的下拉菜单才能查看到全部的止损单并进行调整，如下图所示。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-22.jpg" /></p>
              <p class="pproduct">注：</p>
              <p class="pproduct">
                1、如果暂停再重新启用跟踪止损，会按照启用后出现的最高（低）价减(加)回撤价差重新计算止损价。
              </p>
              <p class="pproduct">
                2、同一个合约上设置的多个云端止损/止盈单，哪一个先触发条件，就先执行哪一条止损。
              </p>
              <h5 class="head5">6、止损止盈单的委托价格</h5>
              <p class="pro">如下图所示是如何设置止损止盈委托价格。</p>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-23.png')"></BaseBigimg>
            </div>
            <div v-if="form.eleventh">
              <h4 class="head4" id="eleven">十、多账号画线下单</h4>
              <h5 class="head5">1、调出画线下单工具</h5>
              <p class="pproduct">
                “多账号”下单支持画线下单，如下图所示是如何调出画线下单界面。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-24.jpg" /></p>
              <h5 class="head5">2、对账号设置画线下单</h5>
              <p class="pproduct">如下图所示是对账号设置画线下单的步骤：</p>
              <p class="pproduct">
                选择划线动作后，鼠标移动到图表预画线的位置，单击鼠标左键，画线完成。当最新价碰触画线时自动发出相应委托（像开盘价格跳空，直接穿越画线的情况也可触发委托）。
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-25.jpg" /></p>
              <h5 class="head5">3、画线下单板按钮解析</h5>
              <p class="pproduct">
                <span style="font-weight: bold">买/卖：</span>画买/卖开仓线；
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">平：</span
                >画平仓线(根据持仓自动判断方向)；
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">反：</span
                >画反手线（平仓成交后反向开仓，如果既有多头又有空头，需根据提示选择反手方向）；
              </p>
              <h5 class="head5">4、画线下单委托价格、启动止损设置</h5>
              <p class="pproduct">
                在【参数设置】的【条件单参数】下，“画线下单委托价”、“画线下单自动止损”位置设置，如下图所示。
              </p>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-26.jpg')"></BaseBigimg>
            </div>
            <div v-if="form.twelveth">
              <h4 class="head4" id="twelve">十一、多账号下单参数设置</h4>
              <p class="pproduct">
                在下单界面【参数设置】中可以对“多账号”下单的超价参数、追价参数、止损参数、条件单参数等进行设置，如下图所示
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-27.jpg" /></p>
              <h5 class="head5">1、选项设置：</h5>
              <p class="pproduct">
                <span style="font-weight: bold">①、交易声音提示：</span
                >勾选该项软件会在委托发出，委托成交时给出声音提示。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">②、双击持仓操作确认：</span
                >勾选该项，当双击持仓列表时，相应操作会弹出确认提示。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">③、持仓列表多空分列：</span
                >勾选该项，持仓列表会自动按照多单持仓和空单持仓分别排列显示仓位。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold"
                  >④、点击最大可开仓手数填单：</span
                >勾选该项，点击下单界面的最大可开仓手数，系统会自动按照该手数填写委托单下单手数。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">⑤、大单拆分：</span
                >当单笔委托数量超过交易所上显示，自动拆分成多笔委托下单。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">⑥、下单默认指定价下单：</span
                >勾选该项，在下单时，软件默认以固定的价格下单。
              </p>

              <p class="pproduct">
                <span style="font-weight: bold">⑦、双击挂单操作确认：</span
                >勾选该项，当双击挂单列表时，相应操作会弹出确认提示。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold"
                  >⑧、单账号点持仓列表填单手数：</span
                >可以通过点持仓列表快速填入手数，支持“该合约全部可用持仓”和“该合约默认手数”两种形式。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">⑨、反手默认下单方式：</span
                >是指在持仓列表单击鼠标右键—>反手或者点击【反手】按钮的委托方式，反手会平仓，平仓成功后再反向开仓。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">⑩、比例平仓下单方式：</span
                >是指通过点击下单界面的比例平仓按钮时的下单方式。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">⑪、账户清仓下单方式：</span
                >是指在持仓列表单击鼠标右键—>撤单平仓+账户清仓的委托方式。撤单平仓+账户清仓会先撤掉已有挂单，然后平掉当前所有持仓。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">⑫、委托确认：</span
                >启用后点击【下单】按钮会弹出下单确认框，点击框中的“确认”按钮才下单。
              </p>

              <h5 class="head5">2、默认手数：</h5>
              <p class="pproduct">如下图是如何设置默认下单手数</p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-28.gif" /></p>
              <h5 class="head5">3、超价参数：</h5>
              <p class="pproduct">
                可以为每个合约设置“买超价”“卖超价”参数。在下单界面使用超价下单买入时以“基准价”+N个变动价位发委托，卖出时以“基准价”-N个变动价位发委托。“基准价”和N可以在交易界面左侧菜单【超价参数】中设置。如股指的买超价参数设置为2，在下单界面用超价发买委托时，会以市场的卖价+2*0.2.的价格委托。
              </p>
              <p class="pproduct">如下图所示，是如何设置超价参数：</p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-29.gif" /></p>
              <h5 class="head5">4、追价参数：</h5>

              <p class="pproduct">
                设置追价触发时间以及追价的委托方式。如下图是如何设置追价参数
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-30.gif" /></p>
              <h5 class="head5">5、止损参数：</h5>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-31.jpg')"></BaseBigimg>
              <h5 class="head5">①、时效：</h5>
              <p class="pro">永久有效：止损止盈单设置后在云端运行永久有效</p>
              <h5 class="head5">②、开仓自动止损的基准价：</h5>
              <p class="pro">
                计算止损价格离不开基准价，比如设置开仓后亏损10个点止损，我们要有一个基准价，用它来判断现在亏损了几个点。软件中有两种形式的基准价，分别是第一批成交价和委托发出时对手价。
              </p>
              <h5 class="head5">③、默认策略：</h5>
              <p class="pro">
                这里设置的是开仓自动止损止盈的策略形式，软件提供多种策略组合，一个合约可以同时启用多个止损策略。
              </p>
              <h5 class="head5">④、国内合约默认止损点差参数：</h5>
              <p class="pro">
                这里设置的是开仓自动止损止盈的策略形式，软件提供多种策略组合，一个合约可以同时启用多个止损策略。
              </p>
              <p class="pro">
                止损参数是在计算止损止盈价位时用到的，可以设置跳点（几个最小变动价位），也可以设置价差，价差不同于跳点是具体价格，以股指IF为例：
              </p>
              <p class="pimg"><img src="@/../public/proimg2/dzh-32.png" /></p>
              <p class="pproduct">
                限价止损：开仓后亏损2个价差止损，3000开多，2998止损平仓。
              </p>
              <p class="pproduct">
                限价止盈：开仓后盈利1.6个价差止盈，3000开多，3001.6止盈平仓。
              </p>
              <p class="pproduct">
                跟踪止损：最高价回撤2个价差止损，3000开多，开仓后的最高价达到3010，在3008平仓。
              </p>
              <p class="pproduct">
                保本策略：盈利超过1.6个价差后，再次回到盈利1.6个价差的价位时止损，3000开多，价格上涨超过3001.6后，再次回落到3001.6，保本平仓。
              </p>
              <p class="pproduct">注：当价差设置为0，相当于不启动止损或止盈</p>
              <h5 class="head5">6、条件单参数</h5>
              <BaseBigimg :src="require('@/../public/proimg2/dzh-33.jpg')"></BaseBigimg>
              <p class="pproduct">
                <span style="font-weight: bold">①、画线下单自动止损：</span
                >该项选择“启用”时,画线下单成交后会自动根据【止损参数】中设置的止损策略为合约设置止损止盈。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">②、画线下单委托价：</span
                >画线下单委托条件满足后，会根据这里设置的委托形式结合市场行情发送委托。
              </p>
              <p class="pproduct">
                <span style="font-weight: bold">③、画线下单持续性：</span
                >可以设置永久有效或当前交易日有效。
              </p>
            </div>
            <div v-if="form.thirteenth">
              <h4 class="head4" id="thirteen">十二、常见问题解答</h4>
              <h5 class="head5">
                1、对“组”下单时，如果单账号的“下单倍数”与“下单界面手数”的乘积不是整数倍，下单手数为多少？
              </h5>
              <p class="pproduct">
                答：乘积按照向下取整确定下单手数，如下单倍数是1.5，下单界面的下单手数是3，那么单账号的下单手数是4手（1.5*3=4.5，向下取整）。
              </p>
              <h5 class="head5">
                2、对“组”平仓时，如果某个单账号手数不足，其他平仓手数充足的单账号能否平仓成功？
              </h5>
              <p class="pproduct">
                答：可以平仓成功，平仓手数不足的单账号会平掉现有持仓。
              </p>
              <h5 class="head5">3、如何查询和确认账单？</h5>
              <p class="pproduct">
                答：在软件上方菜单的【账户】—>【期货账户】—>账单查询及密码修改
              </p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        oneth: true,
        // twoth: false,
        // threeth: false,
        fourth: false,
        fiveth: false,
        sixth: false,
        seventh: false,
        eightth: false,
        nineth: false,
        tenth: false,
        eleventh: false,
        twelveth: false,
        thirteenth: false,
        fourteenth: false,
      },
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickthirteen",
    };
  },
  methods: {
    custormAnchor(anchorName) {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });

      this.form[anchorName + "th"] = true;
    },
    oneth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.oneth = true;
      var id = "one";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    twoth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.twoth = true;
      var id = "two";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    threeth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.threeth = true;
      var id = "three";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    fourth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fourth = true;
      var id = "four";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    fiveth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fiveth = true;
      var id = "five";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    sixth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.sixth = true;
      var id = "six";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    seventh() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.seventh = true;
      var id = "seven";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    eightth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.eightth = true;
      var id = "eight";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    nineth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.nineth = true;
      var id = "nine";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    tenth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.tenth = true;
      var id = "ten";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    eleventh() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.eleventh = true;
      var id = "eleven";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    twelveth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.twelveth = true;
      var id = "twelve";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    thirteen() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.thirteenth = true;
      var id = "thirteen";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    fourteenth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fourteenth = true;
      var id = "fourteen";
      this.$router.push({ path: `/proc/productcenter2/${id}` });
      this.custormAnchor(id);
    },
    zero() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
    },
    menu(e) {
      if (
        e.target.scrollTop >= document.querySelector("#one").offsetTop &&
        document.querySelector("#two").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.oneth = true;
        var id1 = "one";
        this.$router.push({ path: `/proc/productcenter2/${id1}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#two").offsetTop &&
        document.querySelector("#three").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.twoth = true;
        var id2 = "two";
        this.$router.push({ path: `/proc/productcenter2/${id2}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#three").offsetTop &&
        document.querySelector("#four").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.threeth = true;
        var id3 = "three";
        this.$router.push({ path: `/proc/productcenter2/${id3}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#four").offsetTop &&
        document.querySelector("#five").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.fourth = true;
        var id4 = "four";
        this.$router.push({ path: `/proc/productcenter2/${id4}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#five").offsetTop &&
        document.querySelector("#six").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.fiveth = true;
        var id5 = "five";
        this.$router.push({ path: `/proc/productcenter2/${id5}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#six").offsetTop &&
        document.querySelector("#seven").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.sixth = true;
        var id6 = "six";
        this.$router.push({ path: `/proc/productcenter2/${id6}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#seven").offsetTop &&
        document.querySelector("#eight").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.seventh = true;
        var id7 = "seven";
        this.$router.push({ path: `/proc/productcenter2/${id7}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#eight").offsetTop &&
        document.querySelector("#nine").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.eightth = true;
        var id8 = "eight";
        this.$router.push({ path: `/proc/productcenter2/${id8}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#nine").offsetTop &&
        document.querySelector("#ten").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.nineth = true;
        var id9 = "nine";
        this.$router.push({ path: `/proc/productcenter2/${id9}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#ten").offsetTop &&
        document.querySelector("#eleven").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.tenth = true;
        var id10 = "ten";
        this.$router.push({ path: `/proc/productcenter2/${id10}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#eleven").offsetTop &&
        document.querySelector("#twelve").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.eleventh = true;
        var id11 = "eleven";
        this.$router.push({ path: `/proc/productcenter2/${id11}` });
      }
      //         else if(e.target.scrollTop>=document.querySelector("#twelve").offsetTop && document.querySelector("#thirteen").offsetTop>e.target.scrollTop ){

      //            this.zero()
      // this.form.twelveth=true
      //         }
      //         else if(e.target.scrollTop>=document.querySelector("#thirteen").offsetTop ){

      //            this.zero()
      // this.form.thirteen=true
      //         }
      else {
        if (this.form.thirteenth == true) {
          this.zero();
          this.form.thirteenth = true;
          var id13 = "thirteen";
          this.$router.push({ path: `/proc/productcenter2/${id13}` });
        } else {
          this.zero();
          this.form.twelveth = true;
          var id12 = "twelve";
          this.$router.push({ path: `/proc/productcenter2/${id12}` });
        }
      }
    },
  },
  mounted() {
    this.custormAnchor(this.$route.params.id);
  },
};
</script>

<style scoped>
.productcenter1html {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  background-size: 100%;
  min-width: 1400px;
  width: 100%;
}
.productcenter1head {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenter1headtext {
  position: absolute;
  top: 90px;
}
.productcenter1body {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenter1bodytag {
  width: 570px;
  height: 644px;
  border-radius: 2%;
  background: url("../../assets/images/ts-3_01.png") no-repeat center;
  background-size: 100% 100%;
  display: inline-block;
}
.productcenter1bodytext {
  display: inline-block;
  margin-top: -669px;
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-3_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
}
.noclick {
  height: 41px;
  line-height: 41px;
  letter-spacing: 1px;

  width: 220px;

  border-top: 1px solid #96a4d9;
  color: #6c7189;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;
  width: 220px;
  letter-spacing: 1px;
  color: #423312;
  text-align: left;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #f59726;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #1a1c4b;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  letter-spacing: 1px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 700px; */
  text-align: justify;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #f59726;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.head5 {
  color: #1a1c4b;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.ppro {
  font-size: 15px;

  letter-spacing: 1px;
  color: #727983;
  line-height: 25px;
  width: 670px;
  padding-left: 2em;
}
.pro {
  font-size: 15px;

  letter-spacing: 1px;
  color: #727983;
  line-height: 25px;
  width: 670px;
  text-indent: 2em;
}
.taghead {
  width: 43px;
  height: 42px;
  float: left;
}
.tagmid {
  width: 158px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.tagfoot {
  width: 9px;
  height: 42px;
  float: left;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #96a4d9;
  color: #6c7189;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickthirteen {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #96a4d9;
  border-bottom: 1px solid #96a4d9;
  color: #6c7189;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickthirteen:hover {
  color: #f59726;
}
.pdf {
    margin-top:18px ;
    height: 90px;
    width: 220px;
    text-align: center;
    line-height: 90px;
}
.pdf a{
  color: #5050cc;
  text-decoration: none;
  font-size: 14px;
}
.pdf a:hover{
  text-decoration:underline;
}
.pdf a:visited{
  color: #5050cc;
}
</style>